module.exports = __webpack_public_path__ + "966bf5518c8d6f6c7b4fb411fdab2a23.svg";